import { useQueryClient } from "@tanstack/react-query";
import { wellnessChecksKeys } from "./queryKey";
import { useCallback } from "react";
import { WellnessCheck } from "../../api/generated";

export const useSyncWellnessCheckCache = () => {
    const queryClient = useQueryClient();

    // キャッシュの同期をとる
    const syncWellnessCheckCache = useCallback(
        (updatedWellnessCheck: WellnessCheck) => {
            // List（全件）
            const allWellnessChecks = queryClient.getQueryData<WellnessCheck[]>(
                wellnessChecksKeys.all
            );
            if (allWellnessChecks) {
                const newArray = [...allWellnessChecks];
                const targetIndex = newArray.findIndex(
                    (x) => x.id === updatedWellnessCheck.id
                );
                newArray[targetIndex] = updatedWellnessCheck;
                queryClient.setQueryData(wellnessChecksKeys.all, newArray);
            }

            // 親単位
            const answererQueryKey = wellnessChecksKeys.answerers(
                updatedWellnessCheck.answererId
            );
            const answererWellnessChecks =
                queryClient.getQueryData<WellnessCheck[]>(answererQueryKey);
            if (answererWellnessChecks) {
                const newArray = [...answererWellnessChecks];
                const targetIndex = newArray.findIndex(
                    (x) => x.id === updatedWellnessCheck.id
                );
                newArray[targetIndex] = updatedWellnessCheck;
                queryClient.setQueryData(answererQueryKey, newArray);
            }

            // 詳細単位
            const detailQueryKey = wellnessChecksKeys.detail(
                updatedWellnessCheck.id
            );
            const detailWellnessChecks =
                queryClient.getQueryData<WellnessCheck[]>(detailQueryKey);
            if (detailWellnessChecks) {
                queryClient.setQueryData(detailQueryKey, updatedWellnessCheck);
            }
        },
        [queryClient]
    );

    return {
        syncWellnessCheckCache,
    };
};
